import _defineProperty from "@babel/runtime/helpers/defineProperty";
/*
 *                     NOTICE
 *            COPYRIGHT 2023 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { ValueTypeWithCardinalityImpl } from "abreact/expression/domain/ValueTypeWithCardinalityImpl";
// import ValueCategoryAndType = Expression.Domain.ValueCategoryAndType;
// import ValueType = Expression.Domain.ValueTypeWithCardinality;

export class ValueCategoryAndTypeImpl {
  constructor(valueCategoryID, valueTypeID, multiple) {
    _defineProperty(this, "valueCategoryID", void 0);
    _defineProperty(this, "valueTypeWithCardinality", void 0);
    this.valueCategoryID = valueCategoryID;
    this.valueTypeWithCardinality = new ValueTypeWithCardinalityImpl(valueTypeID, multiple);
  }
  get valueCategoryIDOrThrow() {
    if (!this.valueCategoryID) {
      throw new Error("Invalid access of valueCategoryID without confirming it is defined for value type: " + this.valueTypeWithCardinality.toString());
    }
    return this.valueCategoryID;
  }
  exactMatch(other) {
    return this.exactCategoryMatch(other) && this.valueTypeWithCardinality.exactMatch(other.valueTypeWithCardinality);
  }
  partialMatch(other) {
    return (this.valueCategoryID == null || this.exactCategoryMatch(other)) && this.valueTypeWithCardinality.partialMatch(other.valueTypeWithCardinality);
  }
  toString() {
    return `${this.valueCategoryID ?? "*"}:${this.valueTypeWithCardinality.toString()}`;
  }
  exactCategoryMatch(other) {
    return this.valueCategoryID != null && other.valueCategoryID != null && this.valueCategoryID === other.valueCategoryID;
  }
}
//# sourceMappingURL=ValueCategoryAndTypeImpl.js.map
